module.exports = __webpack_public_path__ + "img/2.bd58b0f3.jpg";